import styled from "styled-components";

const MOBILE_BREAKPOINT = "768px";

export const MainContainer = styled.div`
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    align-items: flex-end;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const Line = styled.div`
    width: 100%;
    height: 1px;
    background-color: rgba(241, 241, 241, 0.85);
    margin-bottom: 10px;
`;

export const LeftSection = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const RightSection = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const HeaderContainer = styled.div`
    gap: 10px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: column;
        justify-content: flex-start;
        order: -1;
        margin-bottom: 16px;
    }
`;

export const BoxesContainer = styled.div`
    display: flex;
    gap: 16px;
`;

export const SubCompanyContainer = styled.div`
    flex-direction: column;
    display: flex;
    min-width: 250px;
    gap: 5px;
`;

export const DateRangeContainer = styled.div`
    flex-direction: column;
    display: flex;
    min-width: 250px;
    gap: 5px;
`;

export const TransactionTypeContainer = styled.div`
    flex-direction: column;
    display: flex;
    min-width: 225px;
    gap: 5px;
`;

export const LoadContainer = styled.span`
    background-color: #00b894;
    padding: 5px;
    color: white;
    border-radius: 5px;
`;

export const UseContainer = styled.span`
    background-color: #ff5354;
    padding: 5px;
    color: white;
    border-radius: 5px;
`;
